import React from 'react'
import HeroSection from '../../components/products_from_vendors/HeroSection'
import WorkSection from '../../components/products_from_vendors/WorkSection'
import { JoinTeamSection } from '../../components/products_from_vendors/JoinTeamSection'
import CardSection from '../../components/products_from_vendors/CardSection'
import VendorSection from '../../components/products_from_vendors/VendorSection'

const ProductsFromVendors = () => {
  return (
    <div>
    <HeroSection/>
    <VendorSection/>
    <CardSection/>
    <WorkSection/>
    <JoinTeamSection/>
    </div>
  )
}

export default ProductsFromVendors